import React from 'react'
import { RouteComponentProps } from '@reach/router'

const Iscrizioni: React.FC<RouteComponentProps> = ({ children }) => {
  return <div>{children}</div>
}

export default Iscrizioni
